import React from "react";

export const categoryColors = [
  { name: "Red", className: "bg-red-600" },
  { name: "Rose", className: "bg-rose-600" },
  { name: "Pink", className: "bg-pink-600" },
  { name: "Fuchsia", className: "bg-fuchsia-600" },
  { name: "Purple", className: "bg-purple-600" },
  { name: "Violet", className: "bg-violet-600" },
  { name: "Blue", className: "bg-blue-600" },
  { name: "Sky", className: "bg-sky-600" },
  { name: "Teal", className: "bg-teal-600" },
  { name: "Green", className: "bg-green-600" },
  { name: "Emerald", className: "bg-emerald-600" },
  { name: "Lime", className: "bg-lime-600" },
  { name: "Yellow", className: "bg-yellow-600" },
  { name: "Amber", className: "bg-amber-600" },
  { name: "Orange", className: "bg-orange-600" },
  { name: "Gray", className: "bg-gray-600" },
  { name: "Stone", className: "bg-stone-600" },
];

interface ColorDropdownProps {
  onSelect: (color: string) => void;
  selectedColor: string;
}

const isHexColor = (color: string) => /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(color);

const CategoryColorDropdown: React.FC<ColorDropdownProps> = ({ onSelect, selectedColor }) => {
  const hasPresetMatch = categoryColors.some((color) => color.className === selectedColor);
  const previewStyle = isHexColor(selectedColor) ? { backgroundColor: selectedColor } : undefined;

  return (
    <div className="flex items-center gap-2">
      <div
        className={`w-8 h-8 rounded-full border ${!isHexColor(selectedColor) && selectedColor ? selectedColor : ""}`}
        style={previewStyle}
      ></div>
      <select
        className="p-2 border rounded-md cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500"
        value={selectedColor}
        onChange={(e) => onSelect(e.target.value)}
      >
        <option value="">Select a color</option>
        {!hasPresetMatch && selectedColor && (
          <option value={selectedColor}>
            {isHexColor(selectedColor) ? `Custom (${selectedColor})` : selectedColor}
          </option>
        )}
        {categoryColors.map((color) => (
          <option key={color.className} value={color.className}>
            {color.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CategoryColorDropdown;
